export default __webpack_public_path__ + "static/media/jara.6ac9e090.svg";